const formatPrice = (price: string | number | undefined) => {
  return parseFloat(String(price)).toFixed(2).replace('.', ',');
};

export default formatPrice;
